import { ApplicationController } from 'stimulus-use';

/**
 * GPE (NC34): the projects list toolbar actions that drive the tree.
 *
 * Lives in the sub-header, a different turbo-frame from the table that owns the
 * rows, so it talks to the collapse controller through a window event
 * (`gpe:projects-tree`, detail: { collapse }) rather than a Stimulus outlet. The
 * single chevron button toggles between expand-all and collapse-all; the
 * overflow menu offers the two as explicit entries.
 */
export default class OpProjectsToolbarController extends ApplicationController {
  static targets = ['toggle'];

  declare readonly toggleTarget:HTMLElement;
  declare readonly hasToggleTarget:boolean;

  allCollapsed = false;

  toggleAll(event:Event) {
    event.preventDefault();
    this.allCollapsed = !this.allCollapsed;
    this.emit(this.allCollapsed);
    this.reflectToggle();
  }

  collapseAll(event:Event) {
    event.preventDefault();
    this.allCollapsed = true;
    this.emit(true);
    this.reflectToggle();
  }

  expandAll(event:Event) {
    event.preventDefault();
    this.allCollapsed = false;
    this.emit(false);
    this.reflectToggle();
  }

  private emit(collapse:boolean) {
    window.dispatchEvent(new CustomEvent('gpe:projects-tree', { detail: { collapse } }));
  }

  private reflectToggle() {
    if (!this.hasToggleTarget) { return; }
    this.toggleTarget.classList.toggle('-all-collapsed', this.allCollapsed);
    this.toggleTarget.setAttribute(
      'aria-label',
      this.allCollapsed ? 'Expandir todos os projectos' : 'Recolher todos os projectos',
    );
    this.toggleTarget.setAttribute('title', this.allCollapsed ? 'Expandir' : 'Recolher');
  }
}
